export type SortOrder = 'asc' | 'desc';

const sortBy = <T>(key: keyof T, order: SortOrder = 'asc') => (a: T, b: T) => {
  if (a[key] < b[key]) {
    switch (order) {
      case 'desc':
        return 1;
      default:
        return -1;
    }
  }

  if (a[key] > b[key]) {
    switch (order) {
      case 'desc':
        return -1;
      default:
        return 1;
    }
  }

  return 0;
};

const orderBy = <T>(collections: T[], key: keyof T, order: SortOrder = 'asc') => {
  return collections.sort(sortBy(key, order));
};

export default orderBy;
